module.exports = __webpack_public_path__ + "static/media/btn_android_fr.4c315643.png";